export default __webpack_public_path__ + "static/gs-8-deploymodel--mobile-d8d9790e0b6c0ed18bdf233ee99f723d.jpg";